module.exports = __webpack_public_path__ + "static/media/2H.280e9969.svg";